export const SET_REPORTS = 'SET_REPORTS'
export const CLEAR_REPORTS = 'CLEAR_REPORTS';